module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_noimage_hospital-ea35fa40ed3fa64e44118c5455f65161.png";